import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';

export default {
  attributeName: 'appConfigs',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  canModify:true,
  editURL: routes.CONFIG_EDIT,
  modifyURL:routes.CONFIG_RULES,
  createPath: routes.CONFIG_NEW,
  emptyMessage: "You don't have any configs yet. Click the \"New\" button to create one.",
  isMultiSelectable:true,
  bulkSelectable: true,
  bulkButtons: [
    {
      label: "Import config",
      color: ButtonTheme.INFO,
      action: "bulkImport",
      actionUrl: "appConfig/bulkImport",
      type: BulkImportTypes.WHITELABELCONFIG,
      title: "Import elements",
      showNumberElems: false,
      sessionParams: ['appId'],
      formConfig: [
        {
          attributeName: 'type',
          helpText: 'Type of import',
          type: FormInputTypes.TEXT_INPUT.TEXT,
          required: true,
          label: 'Type',
          defaultValue: `${BulkImportTypes.WHITELABELCONFIG}_${BulkImportTypes.SPORTROOMCONFIG}`,
          hidden: true
        },
        {
          attributeName: 'config',
          helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
          type: FormInputTypes.SELECT,
          label: 'Config',
          placeholder: 'Please enter to add a valid config',
          multiple: false,
          disabledWhenEdit: true,
          url: 'appConfigslistPlay/appId?type=list',
          enabledWhen: { "field": "app", "notValues": ['(Empty)'] },
          emptyValue: true,
          default: '(Empty)',
          options:[],
          session: ['appId'],
          fieldValue:'id',
          fieldName:'name',
          asyncSelect: true,
        },
        {

          attributeName: 'composeExperienceCreation',
          helpText: 'Always generate compose experience',
          type: FormInputTypes.CHECKBOX,
          required: true,
          label: 'Duplicate Composed experiences if exist',
        },
        {
          attributeName: 'composeExperienceCreationText',
          helpText: 'Generate compose experience',
          type: FormInputTypes.TEXT,
          disabled: true,
          required: true,
          default: "ATTENTION! If checked, we will create different composed experiences for the new pasted contents.",
          label: 'Compose experience creation',
        },
      ]
    }
  ],
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the config',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'clientConfig',
      label:'Client Config',
      type: FormInputTypes.LINK,
      icon: IconType.GAMEPAD,
      width: '8rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Client config for this',
      exactWidth:'200px'
    },      
  ],
};
